import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { OffersState } from '../redux/reducer';
import { RegisteredDisclaimer } from './';

export const useGetDisclaimer = (legal: string) => {
  const [disclaimer, setDisclaimer] = useState<RegisteredDisclaimer>(null);
  const disclaimers = useSelector((state: OffersState) => state.disclaimers);

  useEffect(() => {
    if (legal && disclaimers) {
      const disc = disclaimers[legal];
      if (disc) {
        setDisclaimer(disc);
      }
    }
  }, [legal, disclaimers]);

  return disclaimer;
};
